import { useNavigate } from "react-router";

export function DatenschutzPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto max-w-4xl px-4 py-6 sm:px-6">
          <button
            onClick={() => navigate("/")}
            className="text-blue-600 hover:text-blue-700"
          >
            ← Zurück
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6">
        <h1 className="mb-8 text-4xl font-bold text-gray-900">
          Datenschutzerklärung
        </h1>

        <section className="space-y-8 text-gray-700">
          <div>
            <p className="font-semibold">Zuletzt aktualisiert: 29. Juli 2026</p>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              1. Verantwortlicher
            </h2>
            <p>
              Verantwortlich für die Datenverarbeitung im Sinne der
              Datenschutz-Grundverordnung (DSGVO) ist:
            </p>
            <p className="mt-3 pl-4 border-l-4 border-blue-600">
              Alexander Bolz
              <br />
              Guttenberger Str. 25
              <br />
              97234 Reichenberg
              <br />
              Telefon: +49 15562 862516
              <br />
              E-Mail:{" "}
              <a
                href="mailto:kontakt@altibo.de"
                className="text-blue-600 hover:text-blue-700"
              >
                kontakt@altibo.de
              </a>
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              2. Allgemeine Informationen
            </h2>
            <p>
              Operio ist eine webbasierte Geschäftsanwendung (SaaS), die es
              Nutzern ermöglicht, Kundendaten, Rechnungen, Zahlungen und
              geschäftliche Informationen zu verwalten. Der Datenschutz ist uns
              sehr wichtig. Diese Datenschutzerklärung erläutert, wie wir deine
              Daten verarbeiten.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              3. Datenerfassung und Verarbeitung
            </h2>

            <h3 className="mb-2 mt-4 text-lg font-semibold text-gray-900">
              3.1 Authentifizierung und Login
            </h3>
            <p>
              Wenn du dich auf Operio registrierst und anmeldest, erfassen wir:
            </p>
            <ul className="mt-2 ml-6 space-y-2 list-disc">
              <li>E-Mail-Adresse</li>
              <li>Passwort (gehasht mit PBKDF2-SHA256)</li>
              <li>Zeitstempel der Registrierung und letzten Anmeldung</li>
            </ul>
            <p className="mt-3">
              <strong>Rechtsgrundlage:</strong> Vertragserfüllung (Art. 6 Abs. 1
              b DSGVO)
            </p>

            <h3 className="mb-2 mt-5 text-lg font-semibold text-gray-900">
              3.2 Geschäftsdaten
            </h3>
            <p>Im Betrieb speicherst du in Operio:</p>
            <ul className="mt-2 ml-6 space-y-2 list-disc">
              <li>
                <strong>Kundendaten:</strong> Namen, Kontaktinformationen,
                Adressen, E-Mails, Telefonnummern
              </li>
              <li>
                <strong>Rechnungsdaten:</strong> Rechnungsnummern, Daten,
                Beträge, Beschreibungen
              </li>
              <li>
                <strong>Zahlungsinformationen:</strong> Zahlungsstatus, Daten,
                Beträge
              </li>
              <li>
                <strong>Einstellungen:</strong> Unternehmensname, Steuernummer,
                Bankdaten
              </li>
            </ul>
            <p className="mt-3">
              <strong>Rechtsgrundlage:</strong> Vertragserfüllung (Art. 6 Abs. 1
              b DSGVO) und berechtigtes Interesse (Art. 6 Abs. 1 f DSGVO)
            </p>

            <h3 className="mb-2 mt-5 text-lg font-semibold text-gray-900">
              3.3 Authentifizierungs-Token
            </h3>
            <p>Für die Sitzungsverwaltung speichern wir:</p>
            <ul className="mt-2 ml-6 space-y-2 list-disc">
              <li>
                <strong>JWT-Token:</strong> Sichere digitale
                Authentifizierungstokens (15 Minuten Gültigkeit)
              </li>
              <li>
                <strong>Refresh-Token:</strong> Zur Verlängerung der Sitzung (7
                Tage Gültigkeit)
              </li>
              <li>
                <strong>Token-Hashes:</strong> Verschlüsselte Versionen für die
                Speicherung
              </li>
            </ul>
            <p className="mt-3">
              <strong>Rechtsgrundlage:</strong> Vertragserfüllung (Art. 6 Abs. 1
              b DSGVO)
            </p>

            <h3 className="mb-2 mt-5 text-lg font-semibold text-gray-900">
              3.4 Server-Log-Dateien
            </h3>
            <p>Der Hosting-Anbieter Cloudflare erfasst automatisch:</p>
            <ul className="mt-2 ml-6 space-y-2 list-disc">
              <li>IP-Adresse</li>
              <li>Browser-Informationen (User-Agent)</li>
              <li>Anfrage-URL und HTTP-Methode</li>
              <li>HTTP-Statuscode</li>
              <li>Zeitstempel der Anfrage</li>
              <li>Referrer-Information</li>
            </ul>
            <p className="mt-3">
              Diese Daten sind technisch erforderlich, um die Website zu
              betreiben und zu schützen. Sie werden typischerweise nach 30 Tagen
              gelöscht.
            </p>
            <p className="mt-3">
              <strong>Rechtsgrundlage:</strong> Berechtigtes Interesse (Art. 6
              Abs. 1 f DSGVO) für Sicherheit und Betrieb der Infrastruktur
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              4. Speicherung und Infrastruktur
            </h2>

            <h3 className="mb-2 mt-4 text-lg font-semibold text-gray-900">
              4.1 Cloudflare D1 (Datenbank)
            </h3>
            <p>
              Deine Geschäftsdaten und Authentifizierungsinformationen werden in
              einer SQLite-Datenbank gespeichert, die durch Cloudflare D1 in der
              EU (Rechenzentrum in Frankfurt) gehostet wird. Die Datenbank ist
              von anderen Mandanten durch eindeutige Tenant-IDs isoliert.
            </p>

            <h3 className="mb-2 mt-4 text-lg font-semibold text-gray-900">
              4.2 Cloudflare R2 (Dateispeicher)
            </h3>
            <p>
              PDF-Rechnungen und andere Dateien werden in Cloudflare R2 (Object
              Storage) in der EU gespeichert. Diese sind ebenfalls durch
              Tenant-IDs isoliert.
            </p>

            <h3 className="mb-2 mt-4 text-lg font-semibold text-gray-900">
              4.3 Cloudflare KV (Session-Cache)
            </h3>
            <p>
              Rate-Limiting-Informationen und Session-Metadaten werden temporär
              in Cloudflare KV (Key-Value Store) gespeichert und automatisch
              gelöscht.
            </p>

            <h3 className="mb-2 mt-4 text-lg font-semibold text-gray-900">
              4.4 Verschlüsselung
            </h3>
            <p>
              - <strong>In Transit:</strong> Alle Datenübertragungen erfolgen
              über HTTPS (TLS 1.2+)
              <br />- <strong>At Rest:</strong> Datenbanken und Dateispeicher
              sind verschlüsselt
              <br />- <strong>Passwörter:</strong> Mit PBKDF2-SHA256 (600.000
              Iterationen) gehashed
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              5. Speicherdauer
            </h2>
            <p>
              Deine Daten werden solange gespeichert, wie dein Konto aktiv ist.
              Nach Kündigung oder auf Anfrage können wir dein Konto und alle
              zugehörigen Daten löschen. Server-Log-Dateien werden nach ca. 30
              Tagen automatisch gelöscht.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              6. Deine Rechte
            </h2>
            <p>Gemäß DSGVO hast du folgende Rechte:</p>
            <ul className="mt-2 ml-6 space-y-2 list-disc">
              <li>
                <strong>Auskunftsrecht:</strong> Du kannst einsehen, welche
                Daten wir speichern
              </li>
              <li>
                <strong>Berichtigungsrecht:</strong> Du kannst fehlerhafte Daten
                korrigieren
              </li>
              <li>
                <strong>Löschungsrecht:</strong> Du kannst deine Daten löschen
                lassen ("Recht auf Vergessenwerden")
              </li>
              <li>
                <strong>Einschränkungsrecht:</strong> Du kannst die Verarbeitung
                einschränken
              </li>
              <li>
                <strong>Datenportabilität:</strong> Du kannst deine Daten
                exportieren
              </li>
              <li>
                <strong>Widerspruchsrecht:</strong> Du kannst der Verarbeitung
                widersprechen
              </li>
            </ul>
            <p className="mt-3">
              Für Anfragen kontaktiere uns unter:{" "}
              <a
                href="mailto:kontakt@altibo.de"
                className="text-blue-600 hover:text-blue-700"
              >
                kontakt@altibo.de
              </a>
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              7. Keine Cookies oder Tracking
            </h2>
            <p>
              Diese Website und die Operio-App verwenden{" "}
              <strong>keine Cookies</strong> und
              <strong> kein Tracking</strong> (wie Google Analytics). Wir
              sammeln nur Daten, die für die Funktion der App notwendig sind.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              8. Datenweitergabe
            </h2>
            <p>
              Deine Daten werden <strong>nicht an Dritte weitergegeben</strong>,
              außer wenn:
            </p>
            <ul className="mt-2 ml-6 space-y-2 list-disc">
              <li>
                Dies erforderlich ist, um die Infrastruktur (Cloudflare) zu
                betreiben
              </li>
              <li>Wir dazu durch Gesetz verpflichtet sind</li>
              <li>Du deine explizite Zustimmung gibst</li>
            </ul>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              9. Datenschutzbeauftragter
            </h2>
            <p>
              Wir haben keinen externen Datenschutzbeauftragten bestellt, da wir
              als kleines Unternehmen unter die Schwellenwerte der DSGVO fallen.
              Bei Fragen erreichst du uns direkt unter{" "}
              <a
                href="mailto:kontakt@altibo.de"
                className="text-blue-600 hover:text-blue-700"
              >
                kontakt@altibo.de
              </a>
              .
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              10. Beschwerde
            </h2>
            <p>
              Falls du glaubst, dass deine Datenschutzrechte verletzt wurden,
              hast du das Recht, eine Beschwerde bei der zuständigen
              Datenschutzbehörde einzureichen. In Bayern ist dies:
            </p>
            <p className="mt-3 pl-4 border-l-4 border-blue-600">
              Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)
              <br />
              Postfach 606
              <br />
              91511 Ansbach
              <br />
              <a
                href="https://www.baylda.de/"
                target="_blank"
                rel="noopener"
                className="text-blue-600 hover:text-blue-700"
              >
                www.baylda.de
              </a>
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-2xl font-semibold text-gray-900">
              11. Änderungen dieser Datenschutzerklärung
            </h2>
            <p>
              Wir können diese Datenschutzerklärung jederzeit aktualisieren. Bei
              wesentlichen Änderungen werden wir dich benachrichtigen.
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-gray-50 py-8 mt-12">
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
          <div className="flex flex-col justify-between gap-6 md:flex-row">
            <div className="text-sm text-gray-600">
              © 2026 ALTIBO. Operio ist ein Produkt von Alexander Bolz.
            </div>
            <div className="flex gap-6 text-sm">
              <a
                href="/impressum"
                className="text-blue-600 hover:text-blue-700"
              >
                Impressum
              </a>
              <a href="/datenschutz" className="font-semibold text-gray-900">
                Datenschutz
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
